<template>
  <div>
    <Subtitle :subtitle="rightObj.subTitle" style="height: 15%" />
    <EchartsCom ref="rightEcharts03" :parmas="rightObj.parmas" style="height: 85%" />
    <!-- <Highcharts ref="rightEcharts03" :parmas="rightObj.parmas" style="height: 85%" /> -->
  </div>
</template>

<script>
import Subtitle from "@/components/header/subTitle.vue";
import Highcharts from "@/components/common/highcharts";

import EchartsCom from "@/components/common/echarts.vue";

export default {
  props: {
    rightObj: {
      typeof: Object,
    },
  },
  components: {
    Subtitle,
    EchartsCom,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
